'use es6';

import { createSelector } from 'reselect';
export const getContent = state => state.contentById;
export const getContentById = (state, contentId) => state.contentById.get(contentId);
export const getContentName = createSelector(getContentById, content => content && content.get('name'));